import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';

export default function MlmorderListTableHeader(){
  const {mobileView} = useSelector((state)=>state.menu)
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={2} xs={3} ><Typography variant="h5"> Order By </Typography></Grid>
                        <Grid item lg={1} xs={2} ><Typography variant="h5">{mobileView?'#':'Order #'}</Typography></Grid>
                        <Grid item lg={2} xs={2} ><Typography variant="h5"> Order Date </Typography></Grid>
                        <Grid item lg={2} xs={3} ><Typography variant="h5"> Order Value </Typography></Grid>
                        {/* <Grid item lg={1} xs={1} ><Typography variant="h5"> Partner Id </Typography></Grid>
                        <Grid item lg={1} xs={1} ><Typography variant="h5"> Member Id </Typography></Grid> */}
                        <Grid item lg={2} xs={2} ><Typography variant="h5"> Referral Amount </Typography></Grid>

      </Grid>
      
    )
}